var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SettingsAction from "./SettingsAction";
import SettingsOption from "./SettingsOption";
import SettingsColor from "./SettingsColor";
import SettingsVisibility from "./SettingsVisibility";
import SettingsGrid from "./SettingsGrid";
import SettingsSize from "./SettingsSize";

import "./NavSettings.scss";

var templates = {
    "action": SettingsAction,
    "option": SettingsOption,
    "color": SettingsColor,
    "visibility": SettingsVisibility,
    "grid": SettingsGrid,
    "size": SettingsSize
};

var NavSettings = (_temp2 = _class = function (_Component) {
    _inherits(NavSettings, _Component);

    function NavSettings() {
        var _temp, _this, _ret;

        _classCallCheck(this, NavSettings);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getSettingsTemplate = function (child) {
            var type = child.type,
                options = child.options;


            var SettingsTemplate = void 0;

            if (templates[type]) {
                SettingsTemplate = templates[type];
            } else if (options) {
                SettingsTemplate = templates['option'];
            } else {
                SettingsTemplate = templates['action'];
            }

            return SettingsTemplate;
        }, _this.renderSetting = function (child, index) {
            var SettingsTemplate = _this.getSettingsTemplate(child);

            return React.createElement(
                'li',
                { className: 'nav-settings__item', role: 'menuitem', key: index },
                React.createElement(SettingsTemplate, _extends({}, child, { key: index }))
            );

            return React.createElement(
                'li',
                { className: 'nav-settings__item', role: 'menuitem', key: index },
                React.createElement(SettingsTemplate, _extends({}, child, { key: index, onSettings: _this.onSettings, onChange: _this.onChange }))
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /*
     onSettingsChange = (name, value) => {
        console.log('NavSettings:onChange', name)
        
        if (this.props.onChange) {
            this.props.onSettingsChange(name, value)
        }
    }
     onSettings = (id) => {
        if (this.props.onSettings) {
            this.props.onSettings(id)
        }
    }
    
    */

    NavSettings.prototype.render = function render() {
        var settings = this.props.settings;


        if (!settings.length) {
            return false;
        }

        return React.createElement(
            'ul',
            { className: 'nav-settings', role: 'menubar' },
            settings.map(this.renderSetting)
        );
    };

    return NavSettings;
}(Component), _class.defaultProps = {
    settings: []
}, _temp2);
NavSettings.propTypes = process.env.NODE_ENV !== "production" ? {
    settings: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool])
    })) } : {};


export default NavSettings;